<template>
  <v-skeleton-loader class="mx-10 my-4" v-if="!device_data" type="image" />
  <div v-else :id="`con_${id}`" class="container pa-0">
    <div :id="`${id}`" class="svg-container"></div>
  </div>
</template>

<script>
import * as d3 from "d3";
import { axios_get } from "../services/vt_service";
import { h2 } from "../services/powerdata";

export default {
  name: "ScavengerH2Insights",
  props: {
    device_data: Object,
    as_of: String,
  },
  data() {
    return {
      id: "dg_1",
      svg: null,
      div: null,
      type: "multi",
      device_h2_data: null,
    };
  },
  async mounted() {
    await this.getAssetDetails(this.device_data.DeviceID);
    this.initialize();
  },
  methods: {
    initialize() {
      this.createSvg();
      this.drawMessageTimestamp();
      this.drawIncomer();
      this.drawFeeders();
    },
    reDraw() {
      setTimeout(() => {
        if (this.svg) this.svg.remove();
        this.initialize();
      }, 1000);
    },
    async getAssetDetails(id) {
      let response = await axios_get(h2.get_scv_h2_asset, { id: id });
      this.device_h2_data = response[0];
    },
    createSvg() {
      this.svg = d3
        .select(`div#${this.id}`)
        .append("svg")
        .attr("viewBox", [-10, 0, 120, 42])
        .classed("svg-content1", true);
    },
    drawMessageTimestamp() {
      this.svg
        .append("text")
        .attr("class", "timestamp")
        // .attr("font-family", "FontAwesome")
        .attr("font-size", 1.4)
        .attr("x", 80)
        .attr("y", 5)
        .text(this.$formatDateTime(this.device_data.Timestamp));
    },
    drawH2TransformerLabel() {
      if (!this.device_h2_data) return;
      let textArea = this.svg.append("g").attr("class", "text-area").attr("transform", "translate(0,3)");
      textArea
        .append("text")
        .text("H₂:")
        .attr("font-size", 2.2)
        .attr("font-weight", "bold")
        .style("fill", "var(--v-vtblue-base)")
        .attr("transform", "translate(57.5,10)");
      textArea
        .append("text")
        .text(`${this.device_h2_data.H2Lvl} ppm`)
        .attr("font-size", 2.2)
        .attr("font-weight", "bold")
        .style("fill", "var(--v-titleLight-base)")
        .attr("transform", "translate(68,10)");
      textArea
        .append("text")
        .text("Oil Temp:")
        .attr("font-size", 2.2)
        .attr("font-weight", "bold")
        .style("fill", "var(--v-vtblue-base)")
        .attr("transform", "translate(57.5,13)");
      textArea
        .append("text")
        .text(`${((this.device_h2_data.OilTemp * 9) / 5 + 32).toFixed(0)} °F`)
        .attr("font-size", 2.2)
        .attr("font-weight", "bold")
        .style("fill", "var(--v-titleLight-base)")
        .attr("transform", "translate(68,13)");
    },
    drawIncomer() {
      let incomer = this.svg
        .append("g")
        .attr("class", "incomer")
        .attr("transform", "translate(" + 49 + ",4)");

      this.drawCable(incomer, 0, 0, 0, 5);
      this.drawTransformer(incomer);
      this.drawH2TransformerLabel();
      this.drawCable(incomer, 0, 13.2, 0, 19);
    },
    drawCable(incomer, x1, y1, x2, y2) {
      incomer
        .append("line")
        .style("stroke", "#1b428b")
        .style("stroke-width", 0.3)
        .attr("x1", x1)
        .attr("y1", y1)
        .attr("x2", x2)
        .attr("y2", y2);
    },
    drawTransformer(incomer) {
      incomer
        .append("path")
        .attr("fill", "none")
        .attr("stroke", "#1b428b")
        .attr("stroke-width", 0.3)
        .attr("d", d3.symbol().size(22))
        .attr("transform", "translate(0,7.5)");
      incomer
        .append("path")
        .attr("fill", "none")
        .attr("stroke", "#1b428b")
        .attr("stroke-width", 0.3)
        .attr("d", d3.symbol().size(22))
        .attr("transform", "translate(0,10.5)");
    },
    drawFeeders() {
      let feeder = this.svg
        .append("g")
        .attr("class", "feeder")
        .style("fill", "var(--v-titleLight-base)")
        .attr("transform", "translate(" + 10 + "," + 13 + ")");
      feeder
        .append("line")
        .style("stroke", "#1b428b")
        .style("stroke-width", 0.3)
        .attr("x1", 0)
        .attr("y1", 10)
        .attr("x2", 85)
        .attr("y2", 10);
    },
  },
};
</script>

<style lang="scss">
@keyframes highlight {
  0% {
    fill: #c63e12;
  }
  50% {
    fill: rgb(221, 53, 53);
  }
}
@keyframes highlightStroke {
  0% {
    stroke: #c63e12;
  }
  50% {
    stroke: rgb(221, 53, 53);
  }
}
@keyframes dash {
  from {
    stroke-dashoffset: 50;
  }
  to {
    stroke-dashoffset: 10;
  }
}
@keyframes dashError {
  from {
    stroke-dashoffset: 10;
  }
  to {
    stroke-dashoffset: 50;
  }
}
.info {
  font-size: 0.11rem;
}
.stats {
  color: white;
}
.feeder-name {
  color: white;
  cursor: default;
}

.helper {
  fill: #a1c7e2;
}
.warning {
  fill: #c63e12;
  font-weight: bold;
  animation-name: highlight;
  animation-duration: 1s;
  animation-iteration-count: infinite;
  cursor: pointer;
}
.timestamp {
  fill: var(--v-primaryGrey-base);
  font-weight: bold;
  // animation-name: highlight;
  // animation-duration: 1s;
  // animation-iteration-count: infinite;
  // cursor: pointer;
}
.warning path.icon {
  stroke: #c63e12;
  animation-name: highlightStroke;
  animation-duration: 1s;
  animation-iteration-count: infinite;
}

.warning path.shadow {
  stroke: grey;
  animation: none;
}
path.inactive,
line.inactive {
  stroke: grey !important;
}
// .inactive {
//   fill: grey !important;
// }
path.active,
line.active {
  stroke: #1b428b;
}

text.inactive {
  fill: grey;
}
.positive-flow {
  stroke-dasharray: 1;
  animation: dash 5s linear infinite;
}
.negative-flow {
  stroke-dasharray: 1;
  animation: dashError 5s linear infinite;
}
div.insights-tooltip {
  position: absolute;
  width: 420px;
  height: 220px;
  padding: 10px;
  font-size: 12px;
  pointer-events: none;
  border: none;
  opacity: 0;
  box-shadow:
    -3px -1px 20px 0 rgba(0, 0, 0, 0.18),
    0 6px 20px 0 rgba(153, 155, 168, 0.1);
  z-index: 99;
}
div.insights-tooltip > div {
  margin: 2px 0;
}
.width-20 {
  width: 19%;
}
.width-70 {
  width: 68%;
}
.width-10 {
  width: 13%;
}
.width-9 {
  width: 9%;
}
.width-50 {
  width: 50%;
}
.width-31 {
  width: 31%;
}
.pointer {
  cursor: pointer;
}
#feeder-insights .close-button {
  position: absolute;
  top: 10px;
  right: 10px;
  background-color: #f00;
  color: #fff;
  border: none;
  padding: 5px;
  cursor: pointer;
}
</style>
